/* Shared renderer for Resources article blocks (p / li) — the exact same
   Stripe/Notion-grade typography as the Legal Engine documents. */

export const ArticleBlocks = ({ blocks }) => {
  const out = [];
  let list = [];
  const flushList = () => {
    if (list.length) {
      out.push(
        <ul key={`ul-${out.length}`} className="flex flex-col gap-2 my-3">
          {list.map((b, i) => (
            <li key={i} className="flex gap-3 text-[15px] leading-relaxed text-[#2b2b2b]">
              <span className="mt-[9px] w-1.5 h-1.5 rounded-full bg-[#1D4D3B] shrink-0" aria-hidden="true" />
              <span>{b.text}</span>
            </li>
          ))}
        </ul>
      );
      list = [];
    }
  };
  for (const b of blocks) {
    if (b.t === "li") {
      list.push(b);
    } else {
      flushList();
      out.push(
        <p key={`p-${out.length}`} className="text-[15px] leading-[1.75] text-[#2b2b2b] my-3">
          {b.text}
        </p>
      );
    }
  }
  flushList();
  return out;
};
